import { useNavigate } from 'react-router-dom';

import './DashboardTable.css';

interface Patient {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  status: 'Active' | 'In Progress' | 'Closed';
  lawyerCount: number;
  physicianCount: number;
}

interface Props {
  dashboardData: Patient[];
}

function DashboardTable({ dashboardData }: Props): JSX.Element {
  const navigate = useNavigate();

  const handleViewAnswers = (item: Patient) => {
    navigate(`/questions/${item.userId}`);
  };

  const handlePatientDetailPage = (item: Patient) => {
    navigate(`/patient/${item.userId}`);
  };

  return (
    <table className="dashboard-user-table-container">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Status</th>
          <th>Assigned Lawyers</th>
          <th>Assigned Physicians</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {dashboardData.map((item) => (
          <tr key={item.userId}>
            <td className="dashboard-displayName">
              {item.firstName + ' ' + item.lastName}
            </td>
            <td className="dashboard-userEmail">{item.email}</td>
            <td>
              <button
                className={`dashboard-user-status ${item.status === 'Active' ? 'dashboard-status-active' : 'dashboard-status-progress'}`}
              >
                {item.status}
              </button>
            </td>
            <td>{item.lawyerCount}</td>
            <td className="dashboard-assignedPhy">{item.physicianCount}</td>
            <td>
              <div className="dashboard-user-actions-btns">
                <button onClick={() => handlePatientDetailPage(item)}>
                  Details
                </button>
                <button onClick={() => handleViewAnswers(item)}>
                  Review Case
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default DashboardTable;
